export const palette = {
  primary: {
    main: '#338F6C',
    light: '#5AA688',
  },
  secondary: {
    main: '#FAF9F7',
  },
  text: {
    primary: '#132A39',
    secondary: '#666666',
    tertiary: '#757575',
    disabled: '#9E9E9E',
    link: '#338F6C',
    white: '#FFFFFF',
  },
  divider: '#E0E0E0',
  system: {
    red: '#F44336',
    green: '#2A7559',
    yellow: '#ED6C02',
    blue: '#2196F3',
  },
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
  },
  success: {
    main: '#2A7559',
  },
  warning: {
    main: '#ED6C02',
    secondary: '#FFF5EA',
    dark: '#D74D00',
  },
  error: {
    main: '#F44336',
  },
  action: {
    disabled: '#9E9E9E',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};
